export default __webpack_public_path__ + "static/media/help.2a071e1c.svg";